import React from "react";
import { useIdle } from "react-use";
import { EVENT, dispatchEvent } from "tools/events";
import { sentryCapture } from "sentry/sentry";
import { isIos, isAndroid } from "tools/device";

const shouldTrackError = (window.appversion >= 12009 && isIos()) || isAndroid(); // known error in version 12.0.8 on ios

export const useNotificationsSettings = () => {
  const settings = window.cordova?.plugins?.settings;
  const [opened, setOpened] = React.useState(false);
  const isIdle = useIdle(2000);

  React.useEffect(() => {
    if (opened && !isIdle) {
      dispatchEvent(EVENT.refreshNotifications);
      setOpened(false);
    }
  }, [opened, isIdle]);

  return () => {
    settings?.open(
      isIos() ? "application_details" : "notification_id",
      () => {
        setTimeout(() => setOpened(true), 2500); // opened in combination with isIdle will recognize when user comes back from settings
      },
      () => {
        if (shouldTrackError) sentryCapture("Error opening notifications settings");
      }
    );
  };
};
